import React from 'react';
import { SignupChoiceContainer } from '../../../../containers';

export const SignUpChoice = () => <SignupChoiceContainer />;
